import axios from "axios";

export const SESSION_EXPIRED_EVENT = "session-expired";

let isSessionExpired = false;

export function setupAxiosInterceptor() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (isSessionExpired) {
        return Promise.reject(error);
      }

      if (isAuthenticationError(error)) {
        isSessionExpired = true;
        window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));

        setTimeout(() => {
          isSessionExpired = false;
        }, 5000);
      }

      return Promise.reject(error);
    }
  );
}

function isAuthenticationError(error) {
  if (!error.response) {
    return false;
  }

  const status = error.response.status;
  const data = error.response.data;

  if (status === 401) {
    return true;
  }

  // Code 4.1 = token invalide (convention EtherEgo ServicesError.js)
  if (data && data.success === false && data.data && data.data.code === 4.1) {
    return true;
  }

  return false;
}

export function resetSessionExpiredState() {
  isSessionExpired = false;
}
